import SVG from './SVG'

export const PhoneSVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M14.062.89a1 1 0 0 1 1.105-.884A10 10 0 0 1 24 8.828a1 1 0 0 1-1.987.224 8 8 0 0 0-7.067-7.058A1 1 0 0 1 14.062.89ZM7.788 3.242A1 1 0 0 0 7.126 3h-3.01a1 1 0 0 0-.994 1.083 18.79 18.79 0 0 0 2.914 8.223l.004.008a18.5 18.5 0 0 0 5.693 5.692l.007.005a18.79 18.79 0 0 0 8.184 2.914 1.001 1.001 0 0 0 1.082-1.001v-3.028a1 1 0 0 0-.856-1.015 13.847 13.847 0 0 1-3.023-.754l-.003-.001a1 1 0 0 0-1.053.223l-1.268 1.268a1 1 0 0 1-1.201.162 17 17 0 0 1-6.375-6.375 1 1 0 0 1 .162-1.201l1.268-1.268a1 1 0 0 0 .223-1.053V6.88a13.84 13.84 0 0 1-.754-3.024 1 1 0 0 0-.338-.614ZM3 11C2 8.5.812 5.68 1 4c.28-2.5 2.271-2.859 3-3h3.006C8.5 1 10 2 10.106 3.58l.002.01c.117.884.333 1.753.645 2.59a3 3 0 0 1-.676 3.163l-.004.004-.717.717a15.002 15.002 0 0 0 4.586 4.586l.717-.717.004-.004a3 3 0 0 1 3.164-.675c.836.311 1.705.528 2.59.645h.009a3 3 0 0 1 2.58 3.032L23 20s-.148 3-3.012 3c-1.291 0-5.668-.767-8.988-3-4-2.5-7-7-7-7m10.075-8.192a1 1 0 0 1 1.173-.79 6 6 0 0 1 4.74 4.74 1 1 0 1 1-1.963.383 4 4 0 0 0-3.16-3.16 1 1 0 0 1-.79-1.173Z"
        className="Vector (Stroke)"
        clipRule="evenodd"
      />
    </SVG>
  )
}
